import React, { Children, cloneElement, isValidElement } from 'react';
import { EntityPageContentElement } from '../../components/EntityPageContent';
import { EntityPageAdditionalContent } from '../../components/EntityPageAdditionalContent';
import { EntityPageMainContent } from '../../components/EntityPageMainContent';
import { Box, Cell, Layout, Page } from '@wix/design-system';
import { EntityPageActionButtons } from '../../components/EntityPage';

export function useEntityPageContent(child: EntityPageContentElement) {
  const childrenArray = Children.toArray(child.props.children);

  if (process.env.NODE_ENV !== 'production') {
    if (
      !childrenArray.every(
        (elem) =>
          isValidElement(elem) &&
          (elem.type === EntityPageMainContent ||
            elem.type === EntityPageAdditionalContent),
      )
    ) {
      throw new Error(
        '<EntityPage.Content/> must have only <EntityPage.MainContent/> and <EntityPage.AdditionalContent/> children',
      );
    }

    if (childrenArray.length === 0 || childrenArray.length > 2) {
      throw new Error(
        `<EntityPage.Content/> must have 1 (<EntityPage.MainContent/>) or 2 (<EntityPage.MainContent/> and <EntityPage.AdditionalContent/>) children`,
      );
    }

    if (
      !isValidElement(childrenArray[0]) ||
      childrenArray[0].type !== EntityPageMainContent
    ) {
      throw new Error(
        '<EntityPage.MainContent/> should be the first child of <EntityPage.Content/>',
      );
    }

    if (
      childrenArray.length === 2 &&
      (!isValidElement(childrenArray[1]) ||
        childrenArray[1].type !== EntityPageAdditionalContent)
    ) {
      throw new Error(
        'Only <EntityPage.AdditionalContent/> can be the second child of <EntityPage.Content/>',
      );
    }
  }

  if (isValidElement(childrenArray[0])) {
    childrenArray[0] = cloneElement(
      childrenArray[0],
      {
        span: childrenArray.length === 1 ? 12 : 8,
      } as any,
      childrenArray[0].props.children,
    );
  }

  return (
    <Page.Content key={child.key}>
      <Layout>
        {childrenArray}
        <Cell>
          <Page.Footer>
            <Page.Footer.End>
              <Box gap="SP2">
                <EntityPageActionButtons />
              </Box>
            </Page.Footer.End>
          </Page.Footer>
        </Cell>
      </Layout>
    </Page.Content>
  );
}
